import comp from "./DynamicUrlValidator";
export default comp;
